import {useFormContext} from "react-hook-form";
import {useTranslation} from "react-i18next";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFLookupUnit } from "src/components/Shared/NewForms/NFLookupUnit";
import { NFLookupVatType } from "src/components/Shared/NewForms/NFLookupVatType";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import {NFLookupFixedAsset} from "src/components/Shared/NewForms/NFLookupFixedAsset";
import {NFLookupExpenseItem} from "src/components/Shared/NewForms/NFLookupExpenseItem";
import {NFLookupConstructionObject} from "src/components/Shared/NewForms/NFLookupConstructionObject";
 
export const VendorInvoicesDetailServices = () => {
    const {watch} = useFormContext();
    const {t} = useTranslation();

    return (
        <>
            <NFormTable fieldArray={"services"}>
                
                 <NFLookupProduct
                    title={t("Product")}
                    fieldName="productId"
                    width={200}
                />
                <NFLookupUnit
                    title={t("Unit")}
                    fieldName="unitId"
                    width={200}
                />
                <NFIntInput
                    fieldName={"quantity"}
                    title={t("Quantity")}
                    width={100}
                />
                <NFIntInput
                    fieldName={"price"}
                    title={t("Price")}
                    width={100}
                />
                <NFIntInput
                    title={t("Amount")}
                    fieldName="amount"
                    width={100}
                />
                <NFLookupExpenseItem
                    title={t("ExpenseItem")}
                    fieldName="expenseItemId"
                    width={400}
                />
                {/*<NFIntInput title={t("Taxation")} fieldName="taxation"/>*/}
                {/*<NFIntInput title={t("vatRate")} fieldName="vatRate"/>*/}
                <NFLookupVatType title={t("vatType")} fieldName="vatTypeId" width={150}/>
                <NFIntInput title={t("VatAmount")} fieldName="vatAmount" width={100}/>
                <NFIntInput
                    title={t("amountWithVat")}
                    fieldName="amountWithVat"
                    width={100}
                />
                <NFLookupFixedAsset
                    title={t("FixedAsset")}
                    fieldName="fixedAssetId"
                    width={300}
                />
                <NFLookupConstructionObject
                    title={t("ConstructionObject")}
                    fieldName="constructionObjectId"
                    width={300}
                />
            </NFormTable>
        </>
    );
};
